// Campus photo for /colleges/western-michigan-university: Public domain, by BroncoBoy, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AWestern_Michigan_University_-_East_Hall.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/western-michigan-university/; credited under the photo.
const photo = {
    "slug": "western-michigan-university",
    "alt": "East Hall, with its columned portico and ivy, on the campus of Western Michigan University in Kalamazoo, Michigan",
    "src": "/colleges/western-michigan-university/campus-1600.webp",
    "srcSmall": "/colleges/western-michigan-university/campus-800.webp",
    "srcMid": "/colleges/western-michigan-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/western-michigan-university/og.jpg",
    "title": "Western Michigan University - East Hall",
    "author": "BroncoBoy",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AWestern_Michigan_University_-_East_Hall.JPG",
    "read": "2026-10-01"
};

export default photo;
